import { memo } from "react";
import Markdown from "react-markdown";
import remarkGfm from 'remark-gfm'
import useAnalytics from "../../../../hooks/useAnalytics";
import {
  ThumbDownFillIcon,
  ThumbDownIcon,
  ThumbUpFillIcon,
  ThumbUpIcon,
} from "../../../icons";
import styles from "./styles.module.css";

export const Message = memo(
  ({
    isTerms,
    isBotMessage,
    headText,
    messageText,
    time,
    isLoading,
    aIAssistantText,
    meText,
    isReactable,
    isLiked,
    onLike,
    onDislike,
    checkboxLabel,
    isAgreeWithTerms,
    handleTermsClick,
  }) => {
    const { captureEvent } = useAnalytics();

    const markedContent = messageText?.replace("[[1]]", `\n Sources: [[1]]`);

    return (
      <div className={styles.chatBotMessageWidget}>
        <div
          className={`${styles.chatBotMessage}${
            !isBotMessage ? ` ${styles.alignRight}` : ""
          }`}
        >
          <div className={styles.chatBotMessageContainer}>
            <div className={styles.botMessageContainer}>
              <div
                className={`${styles.chatBotMessageBox} ${
                  isBotMessage ? styles.botMessage : styles.userMessage
                }`}
              >
                {isLoading && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`icon icon-tabler icons-tabler-outline icon-tabler-loader infiniteRotating`}
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 6l0 -3" />
                    <path d="M16.25 7.75l2.15 -2.15" />
                    <path d="M18 12l3 0" />
                    <path d="M16.25 16.25l2.15 2.15" />
                    <path d="M12 18l0 3" />
                    <path d="M7.75 16.25l-2.15 2.15" />
                    <path d="M6 12l-3 0" />
                    <path d="M7.75 7.75l-2.15 -2.15" />
                  </svg>
                )}

                {!isLoading && (
                  <>
                    {headText && <p className="chatBotFont">{headText}</p>}

                    {isTerms ? (
                      <div className={styles.termsContainer}>
                        <input
                          type="checkbox"
                          id="termsCheckbox"
                          className={styles.checkbox}
                          checked={isAgreeWithTerms}
                          onChange={handleTermsClick}
                        />
                        {checkboxLabel && (
                          <label
                            htmlFor="termsCheckbox"
                            className={styles.termsText}
                          >
                            {checkboxLabel}
                          </label>
                        )}
                      </div>
                    ) : (
                      <Markdown
                        remarkPlugins={[remarkGfm]}
                        components={{
                          a: ({ href, children }) => {
                            const urlPattern = /https:\/\/[^\s]+/g;
                            const textContent = String(children).replace(
                              urlPattern,
                              ""
                            );
                            return (
                              <a
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "var(--chat-bot-secondary-color);",
                                  textDecoration: "none",
                                }}
                                onClick={(e) => {
                                  // raise or handle the source link click event
                                  captureEvent("ClickedSourceLink", {
                                    source_link: href,
                                  });
                                }}
                              >
                                {textContent}
                              </a>
                            );
                          },
                          p: ({ children }) => {
                            return <p>{children}</p>;
                          },
                        }}
                        className="chatBotFont"
                      >
                        {markedContent}
                      </Markdown>
                    )}
                  </>
                )}
              </div>
            </div>
            {isReactable &&
              isBotMessage &&
              !isLoading &&
              (isLiked === null || isLiked === undefined) && (
                <div className={styles.botMessageReactions}>
                  <button onClick={onLike}>
                    <ThumbUpIcon color="white" size={18} />
                  </button>

                  <button onClick={onDislike}>
                    <ThumbDownIcon color="white" size={18} />
                  </button>
                </div>
              )}
            {typeof isLiked === "boolean" &&
              (isLiked ? (
                <ThumbUpFillIcon color="white" size={18} />
              ) : (
                <ThumbDownFillIcon color="white" size={18} />
              ))}
          </div>
        </div>
      </div>
    );
  }
);
